import { createFileRoute } from '@tanstack/react-router';
import { getPageWithContent } from '@/services/docs';
import DocsGroupPage, { DocsGroupPageLoading } from '@/components/Docs/DocsGroupPage';

export const Route = createFileRoute('/developers/v2/$section/$slug')({
  loader: async ({ params }) =>
    getPageWithContent(params.section, params.slug, 'developers', 'v2'),
  pendingComponent: DocsGroupPageLoading,
  component: DevelopersV2Page,
});

function DevelopersV2Page() {
  const page = Route.useLoaderData();
  return <DocsGroupPage page={page} />;
}
